// extracted by mini-css-extract-plugin
var _1 = "ikiHzJ";
var _2 = "gJnwIV";
var _3 = "nOoG45";
var _4 = "Y0UHQq";
var _5 = "HaFU5f";
var _6 = "doIAzk";
var _7 = "eSVeb0";
var _8 = "xRBP69";
var _9 = "TqvxAq";
var _a = "lZBcMU";
export { _1 as "active", _2 as "dot", _3 as "ease-transition", _4 as "gradient-titanic-80", _5 as "linear-transition-05", _6 as "shadow-medium-titanic", _7 as "shadow-medium-titanic-hover", _8 as "shadow-titanic-1", _9 as "shadow-white", _a as "tag" }
